import { Typography, Colors } from 'cio-design-library/design-tokens'
import styled from 'styled-components'
import Media from 'builder/styles/media'

const scoreBarHeightPx = 4

export const JobPostingContainer = styled.div`
  padding: 32px 36px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: ${Colors.White};
  border-radius: 12px;

  ${Media.Phone`
    gap: 16px;
    padding: 24px 16px;
  `};
`

export const Title = styled.div`
  ${Typography.sizes.Subhead};
  font-weight: ${Typography.weights.medium};
  color: ${Colors.Neutral90};
`

export const Caption = styled.div`
  ${Typography.sizes.Caption};
  color: ${Colors.Neutral50};
`

export const BodyTextCaption = styled.div`
  color: ${Colors.Neutral50};
`

export const ScoreBar = styled.div<{ $score: number }>`
  height: ${scoreBarHeightPx}px;
  border-radius: ${scoreBarHeightPx / 2}px;
  background: ${Colors.Neutral10};
  position: relative;

  &:before {
    content: '';
    position: absolute;
    height: ${scoreBarHeightPx}px;
    width: ${props => props.$score}%;
    background: ${Colors.Green40};
    border-radius: ${scoreBarHeightPx / 2}px;
  }
`
